import { useEffect, useRef, useState } from 'react';
import { register, call, remove } from '../funcStore';
import { getVtuberById } from '../api/mockApi';
import { logAction } from '../api/logApi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VTuberProfile from '../components/VTuberProfile';
import StreamTrends from '../components/StreamTrends';
import VTuberVideoList from '../components/VTuberVideoList';

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  linkButton: {
    border: 'none',
    background: 'none',
    padding: 0,
    color: '#4b3f8f',
    font: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  detailMain: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px',
    maxWidth: '720px',
    margin: '0 auto',
    width: '100%',
  },
};

const STATE_BEFORE_INIT = 'beforeInit';
const STATE_LOADING = 'loading';
const STATE_LOADED = 'loaded';
const STATE_NOT_FOUND = 'notFound';

function VTuberDetailPage() {
  const [state, setState] = useState(STATE_BEFORE_INIT);

  const dataRef = useRef({
    vtuberId: call('app.getSelectedVtuberId'),
    vtuber: null,
    clickedTag: "",
  });


  const init = () => {
    register('vtuberDetailPage.load', async (id) => {
      setState(STATE_LOADING);

      const vtuber = await getVtuberById(id);
      dataRef.current.vtuber = sortAttribute(vtuber);

      setState(vtuber ? STATE_LOADED : STATE_NOT_FOUND);
    });

    call('vtuberDetailPage.load', dataRef.current.vtuberId);
  };

  function sortAttribute(result) {
    const attributes = result.attributes;
    const sortedAtrributes = attributes.sort((a, b) => {
      if (a.approved && !b.approved) {
        return -1;
      }
      return 1;
    });
    const value = { ...result, attributes: sortedAtrributes };
    return value;
  }

  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
  }, [state]);

  useEffect(() => {
    return () => {
      remove('vtuberDetailPage.load');
    };
  }, []);

  if (state === STATE_BEFORE_INIT) {
    return null;
  }

  const vtuber = dataRef.current.vtuber;

  return (
    <div style={styles.page}>
      <Header />

      <main style={styles.detailMain}>
        {state === STATE_LOADING && <p>読み込み中...</p>}

        {state === STATE_NOT_FOUND && (
          <p>
            VTuberが見つかりませんでした。
            <button
              type="button"
              style={styles.linkButton}
              onClick={() => call('app.navigateToSearch')}
            >
              検索に戻る
            </button>
          </p>
        )}

        {state === STATE_LOADED && vtuber && (
          <>
            <VTuberProfile vtuber={vtuber} />

            <StreamTrends vtuber={vtuber} />

            <VTuberVideoList vtuberId={vtuber.id} videos={vtuber.videos} />
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}

export default VTuberDetailPage;
